"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarraDeRolagem = void 0;
var estiloBarraDeRolagem = require('./BarraDeRolagem.module.scss');
var react_1 = __importDefault(require("react"));
var BarraDeRolagem = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement("div", { className: estiloBarraDeRolagem }, children));
};
exports.BarraDeRolagem = BarraDeRolagem;
